import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=2b8878a5&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=2b8878a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8878a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8878a5')) {
      api.createRecord('2b8878a5', component.options)
    } else {
      api.reload('2b8878a5', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=2b8878a5&scoped=true&", function () {
      api.rerender('2b8878a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jcP8DZ4yl6zm/JS/comp/DateRange.vue"
export default component.exports